import { useQuery } from '@tanstack/react-query';

import { HeroRecommendation } from '../../models/personalization.model';

import API from '../../services/api';

import _queryKeys from './_queryKeys';

type HeroRecommendationParams = {
    limit: number;
    component_type_id_x?: string;
    component_type_id_y?: string;
};

const getHeroRecommendations = async (
    limit = 10,
    xAxisComponentTypeId?: string,
    yAxisComponentTypeId?: string,
): Promise<HeroRecommendation[]> => {
    const params: HeroRecommendationParams = { limit };

    if (xAxisComponentTypeId) {
        params['component_type_id_x'] = xAxisComponentTypeId;
    }

    if (yAxisComponentTypeId) {
        params['component_type_id_y'] = yAxisComponentTypeId;
    }

    const { data } = await API.getHeroRecommendations(params);

    return data;
};

export default function useGetHeroRecommendations(
    limit = 10,
    xAxisComponentTypeId?: string,
    yAxisComponentTypeId?: string,
) {
    return useQuery<HeroRecommendation[]>({
        queryKey: _queryKeys.getHeroRecommendations(
            limit,
            xAxisComponentTypeId,
            yAxisComponentTypeId,
        ),
        queryFn: () =>
            getHeroRecommendations(
                limit,
                xAxisComponentTypeId,
                yAxisComponentTypeId,
            ),
        enabled:
            (!!xAxisComponentTypeId && !!yAxisComponentTypeId) ||
            (!xAxisComponentTypeId && !yAxisComponentTypeId),
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
}
